import IconWrapper from "@/pages/users/external/details/components/icon-wrapper";
import { Icon } from "@elaniintc/goes-design-system";
import { useState } from "react";
import InsolvencyListModal from "./insolvency-list-modal";
import { useGetInsolvencies } from "@/queries/users/insolvencies.api";

interface InsolvencyWarningBadgeProps {
  userId: string;
  userName: string;
}

export const InsolvencyWarningBadge = ({
  userId,
  userName,
}: InsolvencyWarningBadgeProps) => {
  const [open, setOpen] = useState(false);
  const { data: insolvencies } = useGetInsolvencies(userId);

  const hasActiveInsolvencies = insolvencies?.data?.some(
    (insolvency) => insolvency.status === "ACTIVE",
  );

  if (!hasActiveInsolvencies) {
    return null;
  }

  return (
    <div className="rounded-xl border border-contextual-warning bg-surface p-4 w-full">
      <div className="flex gap-3">
        <div className="flex-1 flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <IconWrapper className="border-contextual-warning-quiet bg-surface-warning-accent size-6 rounded-full">
              <Icon
                type="fas"
                name="sack-dollar"
                className="text-warning-quiet"
                size="xs"
              />
            </IconWrapper>
            <p className="text-warning font-semibold">
              El solicitante tiene infracciones con insolvencias
            </p>
          </div>
          <p className="text-sm text-warning mt-1">
            La solicitud puede seguir su proceso normal, pero no se generará una
            resolución hasta que el solicitante esté solvente, o anules su
            solicitud manualmente.
          </p>
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="cursor-pointer mt-2 inline-flex items-center gap-1 text-sm text-warning font-semibold hover:underline"
          >
            Ver infracciones
            <Icon type="far" name="arrow-up-right" />
          </button>
        </div>
      </div>
      <InsolvencyListModal
        isOpen={open}
        onClose={() => setOpen(false)}
        userId={userId}
        userName={userName}
      />
    </div>
  );
};

export default InsolvencyWarningBadge;
